<template>
    <div>
        <transition name="slide">
            <div
                v-if="activeNotes && activeNotes.length > 0"
                class="agreement agreement--container"
            >
                <div class="agreement__content">
                    <div class="agreement__box">
                        <!-- title -->
                        <div class="agreement__title">
                            <div
                                v-for="(note, index) in activeNotes"
                                :key="`term-title-${index}`"
                                class="agreement__title-item"
                                :class="{
                                    'agreement__title-item--read': note.read,
                                    'agreement__title-item--unread': !note.read,
                                    'agreement__title-item--first': index === 0,
                                }"
                            >
                                <div class="agreement__title-text">
                                    {{ note.title }}
                                </div>
                            </div>
                        </div>
                        <!-- / title -->
                        <!-- content -->
                        <div
                            ref="content" 
                            class="agreement__scroll-container"
                        >
                            <div
                                v-if="loading"
                                class="agreement__loading"
                            >
                                <div class="agreement__spinner"></div>
                            </div>
                            <div
                                v-else
                                ref="content-box"
                                class="agreement__scroll-box"
                                @scroll="onScroll"
                            >
                                <div
                                    v-for="(note, index) in activeNotes"
                                    :id="`content${index}`"
                                    :key="`term-content-${index}`"
                                    :data-term-category="note.insCategory"
                                    :data-term-type="note.noteType"
                                    class="agreement__content-item"
                                    v-html="cleanHtml(note.content)"
                                ></div>
                            </div>
                        </div>
                        <!-- / content -->
                    </div>
                    <div class="agreement__footer">
                        <div class="agreement__footer-text">
                            請滑動並詳閱條款所載完整內容
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
/**
 * 彈跳視窗-同意聲明告知事項
 */
export default {
    name: 'AgreementComponent',
    props: {
        /**
         * 表示要顯示的告知事項和分類
         */
        terms: {
            type: Array,
            default: () => {
                return [];
            }, // [{InsCategory: 'Car', NoteType: 4},{InsCategory: 'Car', NoteType: 5}]
        },
        /**
         * 判斷同意聲明告知事項是否已確認過
         */
        confirmed: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['confirm', 'close'],
    data() {
        /**
         *  @param {Boolean} confirmable 判斷同意聲明告知事項是否已確認過
         *  @param {Boolean} loading  判斷是否顯示 loading 畫面
         *  @param {Array} notes 聲明事項的內容
         *  @param {Boolean} processing 判斷 API-terms 資料是否載入
         * @param {Boolean} isSend 是否要寄送CilentError
         */
        return {
            confirmable: this.confirmed,
            loading: false,
            notes: [],
            processing: true,
            isSend:true
        };
    },
    computed: {
        /**
         * 顯示同意聲明事項條款標題和內容
         * 
         * @returns {Object} 同意聲明事項條款標題和內容
         */
        activeNotes() {
            return _.map(this.terms, (o) => {
                return this.$store.getters['terms/getByNoteType'](o.NoteType);
            });
        },
    },
    mounted() {
        // 檢查是否有必要初始化和載入同意聲明事項的內容
        if (!this.confirmed) {
            // 設置 terms 的預設值
            this.init();
            // 載入資料
            this.loadContent();
        }
    },
    beforeUnmount() {
        // 使 body 元素的內容允許滾動
        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('fixed');
        document.body.classList.remove('xl:relative');
        document.body.classList.remove('bottom-0');
    },
    methods: {
        /**
         * 使用 DOMPurify 將傳入的 html 進行字串的清理，防止 XSS 攻擊
         *
         * @param {String} html 由 API-terms 回傳的每個熱門車險組合的 html 格式
         * @returns {String} 回傳處理過的 HTML 字串
         * @public
         */
        cleanHtml(html) {
            return DOMPurify.sanitize(html, { ADD_ATTR: ['target'] });
        },
        /**
         * 設置 terms 的預設值
         * 
         * @public
         */
        init() {
            this.$store.commit('terms/setInsCategory');
            this.$store.commit('terms/setInactivity');
            for (let i = 0; i < this.terms.length; i++) {
                let item = _.find(this.$store.state.terms.notes, {
                    insCategory: this.terms[i].InsCategory,
                    noteType: this.terms[i].NoteType,
                });

                if (item) {
                    item.active = true;
                    item.order = i + 1;
                }
            }
        },
        /**
         *  打 API-Terms 拿到同意聲明事項的內容
         * 
         *  @public
         */
        loadContent() {
            this.loading = true;
            let payload = _.chain(this.$store.state.terms.notes).filter({active: true}).groupBy('insCategory').map((value, key) => {
                return {
                    InsCategory: key,
                    NoteType: _.map(value, 'noteType'),
                    InsTypes:_.find(this.terms, { NoteType : 6 })?.InsTypes
                };
            }).value();
            axios.post(apiUrl.Terms, {
                Term: payload
            }).then(res => {
                if (res.data.Code !== 200) {
                    this.$store.commit('setDialog', {
                        active: true
                    });
                    return;
                }
                this.loading = false;
                _.forEach(res.data.Data, o => {
                    let item = _.find(this.$store.state.terms.notes, {insCategory: o.InsCategory, noteType: o.NoteType});
                    if (item) {
                        item.id = o.Id;
                        item.loaded = true;
                        item.content = o.Content;
                        item.date = o.Date;
                        item.pdfUrl = o.PDFUrl;
                        if (item.estimateDate) {
                            this.$store.commit('estimate/setValue', { key: item.estimateDate, value: o.Date});
                        }
                    }
                });
                setTimeout(() => {
                    let height = 0;
                    _.forEach(this.$store.state.terms.notes, o => {
                        let d = document.querySelector('[data-term-type="' + o.noteType + '"][data-term-category="' + o.insCategory + '"]');
                        if (o.active) {
                            o.scrollEnd = d.offsetTop + d.clientHeight;
                        }
                        if (d) height += d.clientHeight;
                    });
                    if (this.$refs['content-box'].clientHeight > height) {
                        this.confirmable = true;
                        _.forEach(this.$store.state.terms.notes, o => {
                            o.read = true;
                        });
                    }
                    this.processing = false;
                }, 300);
            }).catch(() => {
                this.$store.commit('setDialog', {
                    active: true
                });
            });
        },
        /**
         *  在滾動畫面時檢查哪些 notes 被讀取，以及是否已滾動到底部
         * 
         *  @param {Number} scrollTop scrollbar 和聲明事項內容框的距離
         *  @param {Number} clientHeight scrollbar 的高度
         *  @param {Number} scrollHeight scrollbar 可以滾動高度
         *  @public
         */
        onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {            
            try {
                if (!this.processing) {
                    // 查找符合特定條件的元素。這些條件是：元素的active屬性為true、loaded屬性為true、read屬性為false，且該元素的scrollEnd屬性減去200後小於或等於scrollTop + clientHeight。
                    let item = _.find(this.$store.state.terms.notes, (o) => {
                        return (
                            o.active &&
                            o.loaded &&
                            !o.read &&
                            scrollTop + clientHeight >= o.scrollEnd - 200
                        );
                    });
                    // 如果找到符合條件的元素，則將該元素的read屬性設為true，表示該元素已經被讀取。
                    if (item) {
                        item.read = true;
                    }
                    // 如果當前的滾動位置已經滾動到了網頁的底部（scrollTop + clientHeight >= scrollHeight - 200），則將this.confirmable設為true，同意按鈕 disable 解除
                    if (scrollTop + clientHeight >= scrollHeight - 200) {
                        this.confirmable = true;
                        this.$emit('confirm');
                    }
                }
            } catch (err) {
                // if(this.isSend){
                //     let body = (err.message ? err.message : '無法取得錯誤訊息。') + '<br/>' + this.$route.path;

                //     let errData = {
                //         Subject: '條款捲動異常',
                //         Body: body,
                //     };
                //     this.isSend = false;
                //     axios.post(apiUrl.SendClientError, errData).catch(err=>{});
                // }
            }
        },
    },
};
</script>

<style scoped lang="scss">
.agreement--container {
    background-color: white;
    margin-top: 0.5rem;
    display: flex;
    flex-direction: column;
    border-radius: 1rem;
    transition: all 0.5s;
    transform: translateY(0);
    margin-inline: auto;
}

.agreement__content {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.agreement__box {
    border-radius: 0.5rem;
    border: 1px solid #E8E8E8; /* gray-400 */
    overflow: hidden;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    margin-inline: auto;
}

.agreement__title {
    height: auto;
}

.agreement__title-item {
    border-left: 1px solid;
    border-right: 1px solid;
    border-bottom: 1px solid;
    font-weight: 500;
    padding: 0.25rem;
}

.agreement__title-item--read {
    background-color: transparent;
    color: #005BAC; /* blue-700 */
    border-color: #005BAC; /* blue-700 */
}

.agreement__title-item--unread {
    background-color: #F4F4F4; /* gray-200 */
    color: #B2B2B2; /* gray-600 */
    border-color: #E8E8E8; /* gray-400 */
}

.agreement__title-item--first {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    border-top: 1px solid #E8E8E8; /* gray-400 */
}

.agreement__title-item--first.agreement__title-item--read {
    border-top: 1px solid #005BAC; /* blue-700 */
}

.agreement__title-text {
    padding: 0.25rem 1rem;
}

.agreement__scroll-container {
    min-height: 8rem;
    height: 18rem;
    padding: 0.25rem;
    flex-grow: 1;
    overflow: hidden;
}

.agreement__loading {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

.agreement__spinner {
    border-radius: 50%;
    border: 4px solid #B2B2B2; /* gray-600 */
    border-top: 4px solid transparent;
    height: 3rem;
    width: 3rem;
    margin-top: 2rem;
    margin-bottom: 1rem;
    animation: spin 1s linear infinite;
}

.agreement__scroll-box {
    padding: 0.5rem 1rem 1rem;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    position: relative;
}

.agreement__content-item {
    margin-top: 0.25rem;
    word-break: break-word;
    text-align: justify;
}

.agreement__footer {
    margin: 1rem;
}

.agreement__footer-text {
    color: #EE5B6E;
    text-align: center;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-button {
    background: transparent;
    border-radius: 4px;
}

::-webkit-scrollbar-track-piece {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: #005BAC;
}

::-webkit-scrollbar-track {
    box-shadow: transparent;
}
@media screen and (max-height: 650px) {
    .mt-32 {
        margin-top: 0;
    }
}
</style>
